import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "../Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import { Globals } from "root/DataFunctions/BaseDataFns";
import { defaultPaginationOptions } from "root/Tables/BaseTableComponents";
import {MessageStatus, IconPath, UserTypes} from "root/DataFunctions/Constants";

const ChildMessageTable = (props) => {

    const imageFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        let url = '';
        let src = '';

        //Check which table view and if sender/recipient is child - so we know which image to show in the message row
        //if birth parent we force src to null to get the default user image
        if(props.page === "inbox" ){
            src = +(row.sender_user_type) === UserTypes.BIRTH_PARENT ? null : row.sender_document_id;
        }
        else
        {
            src = +(row.recipient_user_type) === UserTypes.BIRTH_PARENT ? null : row.document_id;
        }

        if(props.page === "inbox" && +(row.sender_user_type) === UserTypes.CHILD ){
            //Sender is child so get the avatar
            url = src !== null ? Globals.APIFolder + '/images/' + src + '?thumb&size=100' : Globals.APIFolder + '/user/' + row.sender_user_id + '/avatar?thumb&size=100';
        }
        else if(props.page !== "inbox" && +(row.recipient_user_type) === UserTypes.CHILD){
            //Receiver is child so get the avatar
            url = src !== null ? Globals.APIFolder + '/images/' + src + '?thumb&size=100' : Globals.APIFolder + '/user/' + row.recipient_user_id + '/avatar?thumb&size=100';
        }
        else
        {
            //Get the users image or if null default
            url = src !== null ? Globals.APIFolder + '/images/' + src + '?thumb&size=100' : '/images/defaultPerson.jpg';
        }

        return (
            <div className="child-message-image">
                <img className="pic" src={url} />
            </div>
        )
    }

    const nameFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        let formattedName = '';
        
        if(props.page === "inbox") {
            const name = row.posted_by_name !== null && row.posted_by_name !== '' ? row.posted_by_name : row.firstname;
            formattedName = 'From: ' + name;
        } else {
            const name = row.toName !== null && row.toName !== '' ? row.toName : row.recipient_first_name;
            formattedName = 'To: ' + name;
        }

        return (
            <>
                {formattedName}
            </>
        );
    }

    const messageTextFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <><h3 className="child-message-body">- {cell}</h3></>
        );
    }

    const dateFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        //If we have a draft message - set mode to edit
        const mode = +(row.status) === MessageStatus.NOT_SENT ? 'edit' : 'view';
        const page = props.page === "inbox" ? "inbox" : "";

        switch(row.status){
            case MessageStatus.NOT_SENT:
                cell = row.posted_date;
                break;

            case MessageStatus.APPROVED:
                cell = row.updated_date;
                break;

            case MessageStatus.NEW:
                cell = row.posted_date;
                break;

            case MessageStatus.RETURNED:
                cell = row.posted_date;
                break;

            default:
                cell = row.posted_date;
        }

        return (
            <>
                <span>{cell}</span>
                <div 
                    onClick={() => props.showMessageDetail(row, mode, page)}
                    className="child-table-row-pseudo"
                >
                </div>
            </>
        );
    }

    const actionsFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const page = props.page === "inbox" ? "inbox" : "";

        //Can only reply if you have the permissions set
        return (
            <>
           { (+(row.status) !== MessageStatus.NOT_SENT && row.can_reply) &&
                <img 
                    style={{width: "2.5rem", cursor: 'pointer'}}
                    src={IconPath.ICON_MESSAGE_REPLY}
                    alt="Reply message"
                    onClick={() => props.showMessageDetail(row, 'reply', page)}
                    className="child-message-table-reply-icon"
                /> }

           { +(row.status) === MessageStatus.NOT_SENT &&     <img
                    style={{width: "2.5rem", cursor: 'pointer', marginRight: '5px'}}
                    src={IconPath.ICON_MESSAGE_EDIT}
                    alt="Edit message"
                    onClick={() => props.showMessageDetail(row, 'edit', page)}
                />}

           { +(row.status) !== MessageStatus.APPROVED &&     <img
                    style={{width: "2.5rem", cursor: 'pointer'}}
                    src={IconPath.ICON_MESSAGE_DELETE}
                    alt="Delete message"
                    onClick={() => props.showMessageDetail(row, 'delete', page)}
                />}
            </>
        );
    }

    const getColumns = () => {
        const columns = [
            {
                dataField: "sender_user_id",
                text: "Image",
                formatter: imageFormatter,
            },
            {
                dataField: "posted_by_name",
                formatter: nameFormatter,
                text: "name",
            },
            {
                dataField: "title",
                text: "title",
            },
            {
                dataField: "text",
                text: "Body",
                formatter: messageTextFormatter,
            },
            {
                dataField: "edit_submit",
                text: "Options",
                align: 'right',
                formatter: actionsFormatter,
            },
            {
                dataField: "updated_date",
                text: "Date",
                sort: true,
                formatter: dateFormatter,
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable tableClass='passport-table-child' data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default ChildMessageTable;

ChildMessageTable.propTypes = {
    letter_box_item_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};